<div class="modal-header">
    <i class="fas fa-info-circle fa-2x infoIcon"></i>&nbsp;
    <h4 id="alert-modal-title" class="modal-title errorTittle">{{'menu.about' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body bg-gradient-primary body-image">
    <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-6 col-md-9">
            <div class="text-center pt-4">
                <img src="/assets/images/cronoss_logo.png" width="80%">
            </div>
            <div class="card o-hidden border-0 shadow-lg my-5 divAbout">
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-5">
                                <div class="text-center">
                                    Versiones
                                </div>
                                <hr>
                                <div class="text-center">
                                    BD: {{version ? version.db : 'Load...'}}<br>
                                    API: {{version ? version.api : 'Load...'}}<br>
                                    APP: {{version ? version.app : 'Load...'}}<br>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="copyright text-center my-auto">
                <span>&copy; CRONOSS by AECFA 2019</span>
            </div>    
        </div>
    </div>
</div>
